import { z } from 'zod'

export const coordinatesSchema = z.object({
  lat: z.number(),
  lng: z.number(),
})

export const locationSchema = z.object({
  name: z.string().nullable(),
  street: z.string(),
  city: z.string(),
  country: z.string(),
  coordinates: coordinatesSchema.optional(),
})

export type Coordinates = z.infer<typeof coordinatesSchema>
export type LocationDto = z.infer<typeof locationSchema>

const EARTH_RADIUS_M = 6_371_000

/** Great-circle distance between two coordinates, in meters. */
export function distanceMeters(a: Coordinates, b: Coordinates): number {
  const rad = Math.PI / 180
  const dLat = (b.lat - a.lat) * rad
  const dLng = (b.lng - a.lng) * rad
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)))
}
